import {setDrawingHighlights} from '../context/DrawingContext'

export const highlightAvailableRooms = ({drawingDispatch, availableRooms}) => {
  let highlights = {}
  availableRooms.forEach(availableRoom => {
    const {bl_id, fl_id, rm_id} = availableRoom
    const roomCode = `${bl_id};${fl_id};${rm_id}`
    highlights[roomCode] = {
      fill: 'rgba(51, 149, 254, 0.38)',
      strokeWidth: '0.3%',
      stroke: '#3395fE'
    }
  })
  setDrawingHighlights({
    dispatch: drawingDispatch,
    assetType: 'rm',
    highlights,
    show: true,
    selector: true
  })
}

export const resetHighlights = ({drawingDispatch}) => {
  setDrawingHighlights({
    dispatch: drawingDispatch,
    assetType: 'rm',
    reset: true
  })
}
